import { defineEvent } from '../types/event';
export var CUSTOMER_PASSWORD_UPDATE = defineEvent({
    platforms: [
        {
            name: 'GTM',
            alias: 'customerPasswordUpdate'
        }
    ]
});
